import { decryptText, encryptText } from "../utils/utils";
import store, { RootState } from "../redux/store";
import { setPermission } from "../redux/reducer/permissionSlice";
import { showSnackbar } from "../redux/reducer/snackbarSlice";
import { GlobalPermissionsPath } from "../App_Config_Constant";

type user_role_permission = {
  uuid: string
  parent_id: string,
  name: string,
  slug: string,
  module_url: string,
  icon: string,
  module_order: string,
  is_navigation: number,
  operations: Array<string>,
}


type Menu = {
  id: number,
  title: string,
  icon: JSX.Element,
  url: string,
  subMenus: Menu[],
  uuid: string,
}

const EnumObj: any = {
  salary1: "/recruitment/onboards",
}



type NavigationItem = {
  id: number;
  title: string;
  icon: string | null;
  url: string;
  uuid: string;
  subMenus: NavigationItem[];
};


export const handleMakingNestedData = (dispatch: any) => {
  const mainPermissionsObject = JSON.parse(decryptText(localStorage.getItem('roles_permissions')) || '{}');
  const user_role_permission: Array<user_role_permission> = [...mainPermissionsObject?.user_role_permission];
  let nestedPermissionsDataArray = store.getState().permission?.nestedPermissionsData ?? [];
  if (!nestedPermissionsDataArray || nestedPermissionsDataArray?.length === 0) {
    const buildNestedArrayWithDetails = (permissions: user_role_permission[]): Array<any> => {
      try {
        const map: Record<string, any> = {};

        // Create a map with uuid as the key
        permissions.forEach((item) => {
          const { uuid, parent_id } = item;

          map[uuid] = map[uuid] || { ...item, children: [] };
          map[uuid] = { ...item, children: map[uuid].children || [] };

          if (parent_id !== "0") {
            // If it's a child, attach it to the parent's children array
            map[parent_id] = map[parent_id] || { children: [] };
            map[parent_id].children.push(map[uuid]);
          }
        });

        // Extract top-level modules
        const nestedArray = Object.values(map).filter((item) => item.parent_id === "0");

        return nestedArray;
      } catch (e: any) {
        dispatch(showSnackbar({ message: "Failed to process permission object: unable to convert array into a nested structure.", type: "error", open: true, }));
        return [];
      }
    };

    // Build the nested array
    const nestedArrayWithDetails: Array<any> = buildNestedArrayWithDetails(user_role_permission);
    if (nestedArrayWithDetails && nestedArrayWithDetails.length > 0) {
      const encryptedNestedData = JSON.stringify(nestedArrayWithDetails);
      const PermissionReduxObject: any = store.getState().permission ?? {};
      const isSuperAdmin = mainPermissionsObject?.user_role?.some((role:any) => role?.role_slug === "super-admin");
      dispatch(setPermission({ ...PermissionReduxObject, nestedPermissionsData: nestedArrayWithDetails, user_role : mainPermissionsObject?.user_role??[],isSuperAdmin:isSuperAdmin  }));
      // localStorage.setItem("nestedPermissionsData", encryptText(encryptedNestedData));
      //localStorage.removeItem("roles_permissions"); // delete old permissions
      // handleNav(dispatch);
      nestedPermissionsDataArray = nestedArrayWithDetails;
    }
  }
  return nestedPermissionsDataArray;
};



export const handleNav = (dispatch: any): any => {
  let navigateTabsArray: any = store.getState().permission?.navigateTabsArray ?? [];
  if (!navigateTabsArray || navigateTabsArray?.length === 0) {
    try {
      const nestedPermissionsDataArray = handleMakingNestedData(dispatch);
      const buildNavigationArray = (nestedArray: any): NavigationItem[] => {
        return nestedArray?.filter((item: any) => item.is_navigation === 1) // Filter items where is_navigation is 1
          ?.map((item: any) => ({
            id: item.module_order && item.module_order.trim() ? Number(item.module_order) : 0,
            title: item.name,
            icon: item.icon || null,
            url: item.module_url,
            uuid: item.uuid,
            subMenus: buildNavigationArray(item.children || []), // Recursively build subMenus
          }))?.sort((a: any, b: any) => a.id - b.id); // Sort by id
      };

      const navigationArray = buildNavigationArray(nestedPermissionsDataArray);
      const PermissionReduxObject: any = store.getState().permission ?? {};
      dispatch(setPermission({ ...PermissionReduxObject, navigateTabsArray: navigationArray, }));
      return navigationArray;
    }
    catch (e: any) {
      dispatch(showSnackbar({ message: "Failed to process permission navigate: unable to navigate tab structure.", type: 'error', open: true }));
    }
  }
  return navigateTabsArray;
}


export const userRolePermissionProvider = (dispatch: any, location: any) => {
  try {
     const reduxPermissionState: any = store.getState().permission ?? {};
     const currentPath = location?.pathname?.split('?')[0];
    if(reduxPermissionState?.getFilterPermissionsObject?.module_url !== currentPath ){
    const nestedPermissionsDataArray = handleMakingNestedData(dispatch);
    const findRouteByPathname = (pathname: string, nestedArray: any[]) => {
      const pathWithoutQuery = pathname.split('?')[0];
      const queue = [...nestedArray]; // Copy the initial array to a queue

      while (queue.length > 0) {
        const current = queue.shift(); // Remove the first element from the queue

        if (current.module_url === pathWithoutQuery) {
          return current; // Return the object if the `module_url` matches
        }

        // If there are children, add them to the queue for further processing
        if (current.children && current.children.length > 0) {
          queue.push(...current.children);
        }
      }
      return null; // Return null if no match is found
    }
    const result = findRouteByPathname(location.pathname, nestedPermissionsDataArray ?? []);
    const globalResult = findRouteByPathname(GlobalPermissionsPath, nestedPermissionsDataArray ?? []);
    const PermissionReduxObject: any = store.getState().permission ?? {};
    dispatch(setPermission({ ...PermissionReduxObject, getFilterPermissionsObject: result,getGlobalPermissionsObject: globalResult }));
    }
  }
  catch (e: any) {
    // console.log("error on userRolePermissionProvider method")
  }
}








export const isPermission = (actionName: string) => {
  const PermissionReduxObject: any = store.getState().permission ?? {};
  // console.log("PermissionReduxObject?.isSuperAdmin:",PermissionReduxObject?.isSuperAdmin);

  if(PermissionReduxObject?.isSuperAdmin && !profileTabPermissions(actionName) ){
    return true;
  }

  // console.log("PermissionReduxObject",PermissionReduxObject)
  const operations: Array<string> = PermissionReduxObject?.getFilterPermissionsObject?.operations || [];
  //return operations?.includes(actionName.toLowerCase());
  //  console.log("operations?.includes(actionName.toLowerCase()",actionName,operations,operations?.includes(actionName.toLowerCase()))
  if (actionName) {
    return operations?.includes(actionName.toLowerCase());
  }
  return false;
}


export const isGlobalPermission = (actionName: string) => {
  const PermissionReduxObject: any = store.getState().permission ?? {};
  if(PermissionReduxObject?.isSuperAdmin){
    return true;
  }
  const operations: Array<string> = PermissionReduxObject?.getGlobalPermissionsObject?.operations || [];
  if (actionName) {
    console.log(actionName,operations?.includes(actionName.toLowerCase()),PermissionReduxObject?.getGlobalPermissionsObject?.operations)
    return operations?.includes(actionName.toLowerCase());
  }
  return false;
}

export const isPermission_using_user_role = (actionName: string) => {
  const userDetails: any = store.getState().authUser ?? {};

  // if (userDetails?.user?.user_role === "vendor") {
  //   return false;
  // }
  return true;
}


export const getAllPermissionsRoutes=(dispatch:any)=>{
  let moduleUrlsFromRedux: any = store.getState().permission?.moduleUrls ?? [];
  if(moduleUrlsFromRedux && moduleUrlsFromRedux?.length === 0){
    const mainPermissionsObject = JSON.parse(decryptText(localStorage.getItem('roles_permissions')) || '{}');
    const user_role_permission: Array<user_role_permission> = mainPermissionsObject?.user_role_permission ?? [];

    //strore all module_urls in redux
    const moduleUrls = user_role_permission?.map((permission:any) => permission?.module_url)?.filter((url:string) => url?.trim() !== "");    
    const PermissionReduxObject: any = store.getState().permission ?? {};
    dispatch(setPermission({ ...PermissionReduxObject, moduleUrls:moduleUrls || [] }));
  }
  return moduleUrlsFromRedux;
}


const profileTabPermissions=(actionName:string)=>{
 return ["tab-userprofile_weekoff", "tab-userprofile_policies", "tab-userprofile_accesscontrol", "update-kyc_detail" ,"update-bank_detail","upload-document_employee_section", "assign-holiday" ,"tab-userprofile_reset-device" , "create-exit_request" ].includes(actionName);
}